export const LEVELS_TO_UNLOCK_CUSTOMERS = {
	FIXED_PRICE: 1,
	WHATEVER_PRICE: 1,
	LAZY: 2,
	BARGAINING: 3,
	CREDIT: 6,
};

// TEMPORARY: end the game after level 7 instead of the final level (10).
// For the 3rd of August 2026 release.
// Card: https://mirqah.kanbanize.com/ctrl_board/8/cards/5076/details/
// Revert by removing TEMP_END_LEVEL and its usages (level epic, goToNewLevel, LoadGameMenu).
export const TEMP_END_LEVEL = 7;

export const MIN_FINANCIAL_STATEMENT_VALUE = -999999;
export const MAX_FINANCIAL_STATEMENT_VALUE = 10000000;
export const MAX_LOGBOOK_INPUT_VALUE = 100000;
export const MAX_LOGBOOK_QUANTITY_VALUE = 99;

export const LEVELS_TO_UNLOCK_FEATURES = {
	'CALCULATOR': 1,
	'KEYS': 1,
	'LOGBOOK_FILL': 2,
	'FINANCIAL_STATEMENTS_VIEW' : 3,
	'HUMAN_RESOURCES': 3,
	'FINANCIAL_STATEMENTS_EDIT' : 4,
	'SALESMAN_1': 4,
	'MAGAZINE_ADS': 4,
	'PLAYER_HEALTH': 5,
	'PROFIT_DISTRIBUTION': 5,
	'CARGO_CARS': 6,
	'BREAKEVEN_TUTORIAL': 6,
	'FINANCIAL_RATIOS_VIEW': 6,
	'FINANCIAL_RATIOS_EDIT': 7,
	'WAREHOUSES': 7,
	'RADIO_ADS': 8,
	'BANNER_ADS': 8,
	'RATIOS_TUTORIAL': 8,
	'NEWSPAPER_ADS':7,
	'TRADESHOWS': 9,
};

// The character icon shows the small pause icon on these levels only.
export const LAST_LEVEL_WITH_SMALL_PAUSE_ICON = 2;

export const CORKBOARD_TUTORIAL_DISPLAY_TYPES = {
	IMAGE: 'image',
	COMPONENT: 'component',
}

export const AD_TYPES = {
	MAGAZINE : 'magazine',
	NEWSPAPER: 'newspaper',
	RADIO: 'radio',
	BANNER: 'banner',
};

export const TURN_PHASES = {
	PREPARATION: 'prep',
	CUSTOMERS: 'customers'
};

export const MAX_CUSTOMERS_IN_VIEW = 5;

export const CREDIT_PERIOD_IN_DAYS = 105;

export const CUSTOMER_TYPES = {
	FIXED_PRICE: 'fixed-price',
	WHATEVER_PRICE: 'whatever-price',
	LAZY: 'lazy',
	BARGAINING: 'bargaining',
	CREDIT: 'credit',
};

export const LEVELS_WITH_NEW_CUSTOMER_TYPES = Object.values(LEVELS_TO_UNLOCK_CUSTOMERS);

export const PRODUCT_TYPES = {
	TABLE: 'table',
	CHAIR: 'chair',
	COUCH: 'couch'
};

export const PRODUCT_TYPES_ARR = [
	PRODUCT_TYPES.CHAIR,
	PRODUCT_TYPES.COUCH,
	PRODUCT_TYPES.TABLE
];

export const CURSOR_TYPES = {
	POINTER: 'pointer',
	ON_CLICK: 'onclick',
	DRAG: 'drag',
	ON_DRAG: 'on-drag',
	TEXT: 'text',
	STANDARD: 'standard',
	DENIED: 'denied',
	LOADING: 'loading',
}

export const LOADING_TYPES = {
	CURSOR: 'cursor',
	INDICATOR: 'indicator',
}

export const MAIN_SCREEN_MODALS = {
	CURRENT_MISSIONS: 'currentMissions',
	FINANCIAL_STATEMENTS_NOT_SUBMITTED_MODAL: 'financialStatementsNotSubmitted',
	MISSION_FAILED: 'missionFailed',
	NEW_LEVEL: 'newLevel',
	NEXT_TURN_CONFIRMATION: 'nextTurnConfirmation',
	POWER: 'power',
	POWER_NEXT_TURN: 'powerNextTurn',
	WELCOME: 'welcome',
	GAME_OVER: 'gameOver',
	RESTART_GAME_CONFIRMATION: 'restartGame',
	MISSOUT_CUSTOMERS: 'missoutCustomers',
	MANDATORY_PROFIT_DISTRIBUTION_MODAL: 'mandatoryProfitDistribution',
	CORKBOARD: 'corkboard',
	NETWORK_ERROR: 'networkError',
};

export const MISSOUT_SCENARIOS = {
	HAS_VALID_VIEWING_CUSTOMERS: 'hasValidViewingCustomers',
	HAS_EXTRA_CUSTOMERS: 'hasExtraCustomers',
	EARLY_LEVEL_AND_NO_STOCK_PURCHASED: 'earlyLevelAndNoStockPurchased',
	TRADESHOW_NEXT_TURN: 'tradeshowNextTurn',
};

export const PURCHASING_MODALS = {
	CONFIRMATION: 'confirmation',
	NOT_ENOUGH_CASH: 'notEnoughCash'
};

export const EXPENSES = {
	ADS: 'Advertising',
	TRADESHOW: 'Tradeshow',
	RENT: 'Rent',
	EMPLOYEE: 'Salaries',
	WAREHOUSE: 'Warehouse',
	CAR: 'Car',
};

export const INCOMES = {
	CREDIT_CUSTOMERS: 'Credit Customers'
};

export const CASH_UPDATES = {
	EXPENSE: 'expense',
	INCOME: 'income',
};

export const JOB_TYPES = {
	BOOKKEEPER: 1,
	NEGOTIATOR: 2,
	SALESMAN: 3
};

export const JOB_TYPES_WITH_BADGES = [JOB_TYPES.SALESMAN, JOB_TYPES.NEGOTIATOR];

export const ADVERTISING_AGENCY_ITEM_TYPES = {
	AD: 'ad',
	TRADESHOW: 'tradeshow',
};

export const DEFAULT_STARTING_DATE = new Date(new Date().getFullYear(), 0, 1);

export const QUARTERS_ENDING_MONTHS =
	['March', 'June', 'September', 'December'];

export const INDONESIAN_SALARY_DISCOUNT = 0.8;

export const COMPONENTS_NAMES = {
	PROCUREMENT: 'procurement',
	PROCUREMENT_BUY_MODAL: 'procurement_buy_modal',
	LOGBOOK: 'logbook',
	INBOX: 'inbox',
	MAIN_SCREEN: 'main_screen',
	LEVELS_MODAL: 'levels_modal',
	GAME_MENU: 'game_menu',
};

export const DRAGGABLE_COMPONENTS = {
	LOGBOOK: 'LOGBOOK',
	CALCULATOR: 'CALCULATOR',
	INBOX: 'INBOX',
	FINANCIAL_STATEMENTS: 'FINANCIAL_STATEMENTS',
	TRADESHOW_SALES_REPORT: 'TRADESHOW_SALES_REPORT',
	HEALTH_BAR_TUTORIAL: 'HEALTH_BAR_TUTORIAL',
	FINANCIAL_RATIOS: 'FINANCIAL_RATIOS',
	RATIOS_TUTORIAL: 'RATIOS_TUTORIAL',
	BREAKEVEN_TUTORIAL: 'BREAKEVEN_TUTORIAL',
};

export const EMPLOYEE_SLUGS = {
	SMITH: 'smith',
	RAVI: 'ravi',
	LORENZO: 'lorenzo',
	BOOKKEEPER2: 'bookkeeper2',
};

export const EMPLOYEES_SMITH_TIME_BETWEEN_SALES = 1000;
export const EMPLOYEES_SMITH_TIME_WAITING_AFTER_NEGOTIATION = 1500;
export const EMPLOYEES_SMITH_TIME_WAITING_TO_RECEIVE_EXTRA_CUSTOMERS = 15000;

export const EMPLOYEES_WORK_STATUS = {
	IDLE: 0,
	IN_PROGRESS: 1,
	DONE: 2,
};

export const MESSAGE_TYPES = {
	SUPPLIER_INVOICE : 'supplier_invoice',
	PAYSLIP: 'payslip',
	PAYMENT_RECEIPT: 'payment_receipt',
	OWN_INVOICE: 'own_invoice',
	RENT_INVOICE: 'rent_invoice',
	ADS_INVOICE: 'ads_invoice',
	TRADESHOW_INVOICE: 'tradeshow_invoice',
	CAR_INVOICE: 'car_invoice',
	PURCHASE_INVOICE: 'purchase_invoice', 
};

export const MESSAGE_CATEGORIES = {
	[MESSAGE_TYPES.PURCHASE_INVOICE] : 'supplier_invoice',
	[MESSAGE_TYPES.ADS_INVOICE] : 'supplier_invoice',
	[MESSAGE_TYPES.TRADESHOW_INVOICE] : 'supplier_invoice',
	[MESSAGE_TYPES.CAR_INVOICE] : 'supplier_invoice',
	[MESSAGE_TYPES.RENT_INVOICE] : 'payment_receipt',
	[MESSAGE_TYPES.OWN_INVOICE] : 'own_invoice',
	[MESSAGE_TYPES.PAYSLIP] : 'payslip',
};

export const CHARACTERS_SLUG = {
	KAKAK: 'kakak',
	AHMET: 'ahmet',
	GOLOFIN: 'golofin',
	TOOHA: 'too7a',
};


export const NEGOTIATOR_ODOMETER_TIMEOUT = 2500;

export const MAX_PLAYER_HEALTH = 120;
export const HEALTH_BAR_SINGLE_DASH_VALUE = 10;
export const PLAYER_HEALTH_UNLOCKED_AT_LEVEL = 5;

export const RESPONSIVE_VARIABLES_CHANGED_EVENT = 'RESPONSIVE_VARIABLES_CHANGED_EVENT';

export const GAME_MENU_ITEM_STATES = {
	DEFAULT: 'default',
	SELECTED: 'selected',
	DISABLED: 'disabled',
}

export const GAME_MENU_ITEMS = {
	'CONTINUE': 'Continue',
	'NEW_GAME': 'New Game',
	'LOAD_GAME': 'Load Game',
	'ENCYCLOPEDIA': 'Encyclopedia',
	'STATS': 'Stats',
	'SETTINGS': 'Settings',
	'LOG_OUT': 'Log out',
};

export const  GAME_MENU_SUB_MENUS = {
	'DEFAULT': 'Default',
	'LOAD_GAME': 'Load Game',
	'STATS': 'Stats',
	'SETTINGS': 'Settings',
	'ENCYCLOPEDIA': 'Encyclopedia',
}
